<template>
  <div class="row layouts mt-2">
    <div class="col-md-12">
      <div class="card">
        <b-row v-if="isError" class="justify-content-center p-1">
          <b-col lg="10">
            <b-alert variant="danger" show dismissible>
              Opps .. Something is wrong
            </b-alert>
          </b-col>
        </b-row>
        <b-row class="justify-content-center p-1">
          <b-col lg="10">
            <b-alert variant="warning" show dismissible>
              If you want to add new product choice, please click name of layout
            </b-alert>
          </b-col>
        </b-row>
        <div class="card-body">
          <div class="row justify-content-end">
            <label for="" class="col-sm-auto">Count </label>
            <strong class="col-sm-auto">{{ formatPriceBasic(totalRows) }}</strong>
          </div>
          <b-table
            responsive
            hover
            :items="items"
            :busy="isLoading"
            :isLoading="isLoading"
            :fields="fields"
            show-empty
          >
            <template #cell(No)="row">
              {{ (currentPage - 1) * perPage + (row.index + 1)}}
            </template>
            <template #cell(name)="row">
              <div class="text-left">
                <router-link :to="{ path :'/layouts/detail/' +row.item.id }">
                  {{ row.item.name }}
                </router-link>
              </div>
            </template>
            <template #cell(Status)="row">
              <div class="text-left">
                <span
                  v-if="row.item.is_active"
                  class="badge badge-primary"
                  >
                  Active
                </span>
              </div>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-dark my-2">
                <svg class="heart" viewBox="0 0 32 29.6">
                  <path
                    d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                    c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                  />
                </svg>
                Loading ...
              </div>
            </template>
          </b-table>
        </div>
        <b-row class="justify-content-start ml-1">
          <b-col lg="3">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="my-table"
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import API from "../../plugins/http"
export default {
  name: "UserBanned",
  data() {
    return {
      currentPage: 1,
      perPage: 100,
      filter: null,
      isLoadingSearch: false,
      items_search: [],
      fields: [
        { key:'No', label: 'No'},
        { key:'name', label: 'Layout Name'},
        { key:'id', label: 'Layout Code'},
        { key:'layout_type', label: 'Layout Type'},
        { key:'Status', label: 'Status'},
      ]
    };
  },
  watch: {
    currentPage: function() {
      this.actionFetchLayouts();
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Layouts Offers | Content Management System Ebooks Gramedia.com';
      }
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.productChoices.isLoading,
      isError: (state) => state.productChoices.isError,
      totalRows: (state) => state.productChoices.totalRows,
			items: (state) => state.productChoices.layouts,
    }),
  },
  mounted() {
    this.actionFetchLayouts();
  },
  methods: {
    ...mapActions("productChoices", ["fetchLayout","fetchLayoutByID"]),
    ...mapMutations("users", ["setItems", "setRows"]),
    actionFetchLayouts() {
      this.fetchLayout();
    },
    actionConfirm(data){
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Unbanned it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let payload = {
              id: data.id,
              user_id : data.user_id,
            }

            API.post('/user-banned/unbanned',payload)
            .then(() => {
              this.$swal({
                toast: "true",
                position: "top-end",
                icon: "success",
                title: "Sucess UnBanned",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              })
              this.asyncFind()
            }).catch(()=> {
               this.$swal({
                toast: "true",
                position: "top-end",
                icon: "error",
                title: "Failed UnBanned",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              })
            })
          }
        });
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    formatPriceBasic(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
